import React from 'react'
import {Field} from 'redux-form'

let PaypalForm = props => {
  const { paypal } = props;

  return (
    <div>
      <h4>PayPal:</h4>
      <div className="form-group">
        <div className="checkbox">
          <label>
            <Field component="input" name="paypal.paypalRecurringBillingAgreement" type="checkbox"/> <b>Recurring Billing
            Agreement</b>
          </label>
        </div>
      </div>
      <div className="form-group">
        <div className="checkbox">
          <label>
            <Field component="input" name="paypal.paypalCallbacks" type="checkbox"/> <b>Use callbacks</b>
          </label>
        </div>
      </div>

      <div>
        <h3>Styles:</h3>
        <div className="form-group">
          <div className="checkbox">
            <label>
              <Field name="paypal.stylesUsage.general" component="input" type="checkbox"/> <b>Use styles:</b>
            </label>
          </div>
        </div>

        {paypal.stylesUsage && paypal.stylesUsage.general && <div>
          <div className="row">
            <div className="col-sm-2">
              <div className="checkbox">
                <label>
                  <Field name="paypal.stylesUsage.label" component="input" type="checkbox"/> <b>Label</b>
                </label>
              </div>
            </div>
            <div className="col-sm-10">
              {paypal.stylesUsage && paypal.stylesUsage.label && <div>
                <Field className="form-control" name="paypal.styles.label" component="input" type="text"/>
              </div>}
            </div>
          </div>

          <div className="row">
            <div className="col-sm-2">
              <div className="checkbox">
                <label>
                  <Field name="paypal.stylesUsage.size" component="input" type="checkbox"/> <b>Size</b>
                </label>
              </div>
            </div>
            <div className="col-sm-10">
              {paypal.stylesUsage && paypal.stylesUsage.size && <div>
                <Field className="form-control" name="paypal.styles.size" component="input" type="text"/>
              </div>}
            </div>
          </div>

          <div className="row">
            <div className="col-sm-2">
              <div className="checkbox">
                <label>
                  <Field name="paypal.stylesUsage.color" component="input" type="checkbox"/> <b>Color</b>
                </label>
              </div>
            </div>
            <div className="col-sm-10">
              {paypal.stylesUsage && paypal.stylesUsage.color && <div>
                <Field className="form-control" name="paypal.styles.color" component="input" type="text"/>
              </div>}
            </div>
          </div>

          <div className="row">
            <div className="col-sm-2">
              <div className="checkbox">
                <label>
                  <Field name="paypal.stylesUsage.shape" component="input" type="checkbox"/> <b>Shape</b>
                </label>
              </div>
            </div>
            <div className="col-sm-10">
              {paypal.stylesUsage && paypal.stylesUsage.shape && <div>
                <Field className="form-control" name="paypal.styles.shape" component="input" type="text"/>
              </div>}
            </div>
          </div>

        </div>}
      </div>

    </div>
  );
};

export default PaypalForm;



// WEBPACK FOOTER //
// ./src/button/products/PaypalForm.js